<template>
  <p
    class="ba-text-sm md:ba-text-center"
    :class="success ? 'ba-text-success' : 'ba-text-smena-error'"
  >
    {{ message }}
  </p>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: ""
    },
    success: {
      type: Boolean,
      default: false
    }
  }
};
</script>
